<div class="xn-carousel">
  <div class="navigation-wrapper">
    <div class="keen-slider keen-slider--vertical" #sliderRef>

      <div *ngFor="let img of images;index as k" class="keen-slider__slide number-slide{{k + 1}}" >
        <div class="xn-carousel-item-content" [style.background-image]="'url(' + img+ ')'" (click)="showGallery(k)"></div>
      </div>
    </div>
    <svg [ngClass]="
        'arrow arrow--left ' + (currentSlide === 0 ? 'arrow--disabled' : '')
      " (click)="prev()" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
      <path d="M16.67 0l2.83 2.829-9.339 9.175 9.339 9.167-2.83 2.829-12.17-11.996z" />
    </svg>
    <svg *ngIf="slider && slider.track?.details?.slides?.length" [ngClass]="
        'arrow arrow--right ' +
        (slider.track.details.slides.length - 1 === currentSlide
          ? 'arrow--disabled'
          : '')
      " (click)="slider.next()" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
      <path d="M5 3l3.057-3 11.943 12-11.943 12-3.057-3 9-9z" />
    </svg>
  </div>
  <div class="dots">
    <button (click)="moveToIndex(i)" *ngFor="let slide of dotHelper; let i = index"
      [class]="'dot ' + (i === currentSlide ? 'active' : '')"></button>
  </div>
</div>

<p-galleria 
  [value]="galleyImageState.images" 
  [(visible)]="galleyImageState.visible" 
  [(activeIndex)]="galleyImageState.activeIndex" 
  [responsiveOptions]="galleyImageState.responsiveOptions" 
  [containerStyle]="" 
  [numVisible]="7"
  [circular]="true" 
  [fullScreen]="true" 
  [showItemNavigators]="true" 
  [showThumbnails]="false" 
  [baseZIndex]="100000"
  class="gallery-images max-w-[95vw] lg:max-w-[80vw]"
  [showIndicators]="true"
  (activeIndexChange)="onGalleryChanged($event)"
  >
    <ng-template pTemplate="item" let-item>
        <img [src]="item" class="block h-auto rounded-none	md:rounded-[12px] w-[95vw] lg:w-[60vw]" />
    </ng-template>
    <ng-template pTemplate="thumbnail" let-item>
        <div class="grid grid-nogutter justify-content-center">
            <img [src]="item" style="display: block;"/>
        </div>
    </ng-template>

    <ng-template pTemplate="indicator" let-index>
      <div 
        class="gallery-indicator"
        [style.width]="getIndicatorSize(index)"
        [style.height]="getIndicatorSize(index)"
      ></div>
    </ng-template>
</p-galleria>